import { useEffect } from 'react';
import { clearAppShellCaches } from '../utils/clearAppCaches';

/** Executa uma vez ao montar: limpa Cache Storage e desregistra SWs (evita assets velhos em produção). */
export function useClearAppCachesOnMount(): void {
  useEffect(() => {
    void clearAppShellCaches();
  }, []);
}
